// call.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
// import { __values } from 'tslib';

@Injectable({
  providedIn: 'root',
})
export class CallService {
  private callState = new BehaviorSubject<string>('idle'); // Possible states: 'idle', 'ongoing', 'ended'
  private callStartTime!: number;
  private callSubject = new BehaviorSubject<boolean>(false);
  private dataSubject = new BehaviorSubject<boolean>(false)
  private draftdata = new BehaviorSubject<any[] | null>(null);


  callSubject$ = this.callSubject.asObservable();
  dataSubject$ = this.dataSubject.asObservable();
  draftData$ = this.draftdata.asObservable()



  getCallState() {
    return this.callState.asObservable();
  }

  getCurrentState() {
    return this.callState.getValue();
  }

  startCall(openSlider: boolean = true) {
    this.callState.next('ongoing');
    this.callStartTime = Date.now();
    if (openSlider) {
      this.callSubject.next(true);
    }
  }

openSlider(isEmpty: boolean, draftItem?: any): void {
  this.callSubject.next(true);

  this.draftdata.next(
    draftItem ? [draftItem] : []
  );

  this.dataSubject.next(!isEmpty);
}

onCloseSlider(){
  this.callSubject.next(false)
}

    // }else{
    //   // console.log(this.dataSubject);
    // // this.callSubject.next(true);
    // console.log(data);


    //   this.callSubject.next(data)
    // }

  endCall() {
    this.callState.next('ended');
    this.callState.next('idle');
  }
}
